export const SpacingIconTypes = {
  EMBED: 'embed',
  IMAGE: 'image',
  VIDEO: 'video',
  TABLE: 'table'
};